export default __webpack_public_path__ + "static/media/settings-error.109c1070.svg";